import { notification } from "antd";
import { createContext, useState, useContext } from "react";

const AuthNotificationContext = createContext();

function AuthNotificationProvider({ children }) {
    const [api, contextHolder] = notification.useNotification();

    /**
     * hàm thông báo
     * @param {string, string}
     * title: tiêu đề
     * position: vị trí hiển thị (topLeft, topRight, bottomLeft, bottomRight)
     */

    const success = (title, position = "topRight") => {
        api.success({
            placement: position,
            message: title,
        });
    };

    const error = (title, position = "topRight") => {
        api.error({
            placement: position,
            message: title,
        });
    };

    return (
        <AuthNotificationContext.Provider value={{ success, error }}>
            {contextHolder}
            {children}
        </AuthNotificationContext.Provider>
    );
}

const useAuthNotification = () => {
    const context = useContext(AuthNotificationContext);
    return context;
};

export { useAuthNotification };
export default AuthNotificationProvider;
